import Grid, { GridProps } from "@mui/material/Grid";

export type { GridProps };
export default Grid;
